const cardPositionConfig = {
    current: null
};
export default cardPositionConfig;
